import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IVentaData } from '@core/interfaces/entidades/venta.entidad';
import { IPaginar } from '@core/interfaces/paginacion/paginacion.interface';

import {
  IAgregarPagoVentaCreditoReq,
  IClienteCreditoListadoRes,
  IEmitirCreditoReq,
  IVerDetalleDeudaClienteCreditoRes,
  IVerDeudaClienteCreditoRes,
} from '@core/interfaces/request-response/credito.dto.interface';
import { IResumenGeneralCreditoRes } from '@core/interfaces/request-response/credito.dto.interface';
import { IRealizarVentaCreditoReq } from '@core/interfaces/request-response/venta.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class CreditoApiService extends BaseHttpService {
  realizarVentaCredito(req: IRealizarVentaCreditoReq) {
    return this.withLoader(
      this.httpClient.post<IVentaData>(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/generar-venta-credito`,
        req,
      ),
    );
  }
  datosGenerales() {
    return this.withLoader(
      this.httpClient.get<IResumenGeneralCreditoRes>(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/credito-resumen-general`,
      ),
    );
  }
  paginar(pagina: number, size: number) {
    const params = new HttpParams().set('pagina', pagina.toString()).set('size', size.toString());
    return this.withLoader(
      this.httpClient.get<IPaginar<IClienteCreditoListadoRes>>(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/lista-clientes-con-credito`,
        { params },
      ),
    );
  }
  verDeudaCliente(clienteId: number, pagina: number, size: number) {
    const params = new HttpParams().set('pagina', pagina.toString()).set('size', size.toString());
    return this.withLoader(
      this.httpClient.get<IPaginar<IVerDeudaClienteCreditoRes>>(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/ver-deudas-cliente/${clienteId}`,
        { params },
      ),
    );
  }
  verVentaDeudaCliente(ventaId: number) {
    return this.withLoader(
      this.httpClient.get<IVerDetalleDeudaClienteCreditoRes>(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/ver-venta-credito/${ventaId}`,
      ),
    );
  }
  agregarPago(pago: IAgregarPagoVentaCreditoReq) {
    return this.withLoader(
      this.httpClient.post<IVerDetalleDeudaClienteCreditoRes>(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/agregar-pago-venta-credito`,
        pago,
      ),
    );
  }
  actualizarObservacionesPagoCredito(ventaId: number, observaciones: string) {
    return this.withLoader(
      this.httpClient.put(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/actualizar-observaciones/${ventaId}`,
        {
          observaciones,
        },
      ),
    );
  }
  emitirCredito(credito: IEmitirCreditoReq) {
    const params = new HttpParams().set('async', environment.asyncServices.toString());
    return this.withLoader(
      this.httpClient.post<{ message: string }>(
        `${environment.apiUrl}${environment.apiPreFix}/venta/v2/emitir-credito`,
        credito,
        { params },
      ),
    );
  }
}
